import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpParamsBuilder, Response, Vehicle, VehiclesApiService } from '@agilox/common';

@Injectable({
	providedIn: 'root',
})
export class VehiclesService {
	private vehiclesApiService = inject(VehiclesApiService);

	loadVehiclesResponse(serials: string[]): Observable<Response<Vehicle>> {
		let params = HttpParamsBuilder.buildParameters(
			{ number: 0, size: serials.length },
			undefined,
			undefined,
			{
				serial: serials.join(','),
			}
		);
		return this.vehiclesApiService.fetch(params);
	}

	loadVehicles(serials: string[]): Observable<Vehicle[]> {
		return this.loadVehiclesResponse(serials).pipe(
			map((data: Response<Vehicle>) => {
				let vehicles = [];
				if (data.status) {
					vehicles = data.data as Vehicle[];
				}
				return vehicles;
			})
		);
	}

	loadDefaultVehicle(): Observable<Vehicle | undefined> {
		let params = HttpParamsBuilder.buildParameters({ number: 0, size: 1 });
		return this.vehiclesApiService.fetch(params).pipe(
			map((data: Response<Vehicle>) => {
				let vehicles = [];
				if (data.status) {
					vehicles = data.data as Vehicle[];
					return vehicles[0];
				}
				return undefined;
			})
		);
	}
}
